var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserGroupIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "19px",
    viewBox: "0 0 22 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "40ACAA9A-2B2A-4B29-96E1-F5CE13EA66AA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.607843 0 0 0 0 0.662745 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "14.0_Store-Template_03.1",
    transform: "translate(-564.000000, -622.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(532.000000, 525.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Actions",
    transform: "translate(32.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-group-(1)",
    transform: "translate(0.000000, 77.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9781131,8.94539275 C13.0531825,8.94539275 14.7355321,6.94429003 14.7355321,4.47588117 C14.7355321,2.00741692 14.1831003,0.0063141994 10.9781131,0.0063141994 C7.77301285,0.0063141994 7.22069409,2.00741692 7.22069409,4.47588117 C7.22069409,6.94429003 8.9030437,8.94539275 10.9781131,8.94539275 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0668638,15.5893706 C17.9973573,11.2892346 17.4238869,10.0639476 13.0357635,9.28829809 C13.0357635,9.28829809 12.4179537,10.0591289 10.9782262,10.0591289 C9.53849871,10.0591289 8.92080206,9.28829809 8.92080206,9.28829809 C4.58052442,10.0554179 3.97210283,11.2625932 3.89213368,15.4496274 C3.88562982,15.7915358 3.88263239,15.8094814 3.88144473,15.7697684 C3.88167095,15.8441541 3.88201028,15.9816818 3.88201028,16.221566 C3.88201028,16.221566 4.92675578,18.284149 10.9782828,18.284149 C17.0298098,18.284149 18.0746684,16.221566 18.0746684,16.221566 C18.0746684,16.0674773 18.0748946,15.9602467 18.0748946,15.8874119 C18.0737069,15.9119486 18.0712751,15.8643706 18.0668638,15.5893706 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.192509,8.14736657 C17.8779126,8.14736657 19.2441748,6.52212487 19.2441748,4.51731118 C19.2441748,2.51244209 18.7955784,0.887200403 16.192509,0.887200403 C15.7546581,0.887200403 15.3778869,0.933338369 15.0537686,1.01946626 C15.6550077,2.10495468 15.7374087,3.42340383 15.7374087,4.47582578 C15.7374087,5.66743706 15.4075784,6.8051007 14.8001748,7.74707956 C15.2176658,8.00241692 15.6907506,8.14736657 16.192509,8.14736657 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9497224,13.5434592 C21.8931671,10.0509869 21.427491,9.05583585 17.863491,8.42585599 C17.863491,8.42585599 17.3617892,9.05195871 16.1924524,9.05195871 C16.1440977,9.05195871 16.0972134,9.05051863 16.0510643,9.04846928 C16.7940308,9.37653072 17.4699229,9.83331319 17.9676658,10.5017321 C18.8281542,11.657286 19.0259846,13.2095821 19.0668175,15.4900604 C21.4645913,15.0260222 21.956,14.0570141 21.956,14.0570141 C21.956,13.9307301 21.956,13.8441037 21.9562262,13.7848943 C21.9552648,13.80572 21.9532853,13.7683887 21.9497224,13.5434592 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76366067,8.14736657 C6.26547558,8.14736657 6.7384473,8.00241692 7.15610797,7.74713494 C6.54870437,6.80515609 6.21887404,5.66749245 6.21887404,4.47588117 C6.21887404,3.42340383 6.30127506,2.10495468 6.90240103,1.01952165 C6.57833933,0.933393756 6.20162468,0.887255791 5.76366067,0.887255791 C3.16059126,0.887255791 2.71210797,2.51249748 2.71210797,4.51736657 C2.71210797,6.52212487 4.07837018,8.14736657 5.76366067,8.14736657 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90504884,9.0484139 C5.85901285,9.05046324 5.81212853,9.05190332 5.76366067,9.05190332 C4.59432391,9.05190332 4.09262211,8.4258006 4.09262211,8.4258006 C0.528735219,9.05578046 0.0629460154,10.0508761 0.00650385604,13.5434038 C0.0028277635,13.7683887 0.000961439589,13.8056647 4.01849362e-16,13.7847835 C0.00011311054,13.843993 0.00022622108,13.9306193 0.00022622108,14.0569033 C0.00022622108,14.0569033 0.491691517,15.0259114 2.88929563,15.4899496 C2.9302982,13.2095267 3.12801542,11.6572306 3.98861697,10.5016213 C4.48630334,9.83331319 5.16208226,9.37647533 5.90504884,9.0484139 Z",
    id: "Path",
    fill: "currentColor",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroupIcon);
export default __webpack_public_path__ + "static/media/UserGroupIcon.054177c0245ac41a8b0b8bac5afb9d3c.svg";
export { ForwardRef as ReactComponent };